import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  footer?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, footer, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("shadow-card rounded-2xl bg-white p-8", className)} {...props}>
        {children}
        {footer && <footer className="mt-8 border-t border-gray-200 pt-6">{footer}</footer>}
      </div>
    );
  }
);

Card.displayName = "Card";
